import axios from 'axios'
// import store from '../../store'
import * as helper from '../utils/helper'
import SERVICES_CONFIG from './service.config'

axios.defaults.withCredentials = false;
export default class BaseService {
  API_PATH: string;
  ROOT_URL: string;
  api: {
    createAxiosResponseInterceptor(): void;
    setToken(token: any): void;
    get(path: any, query?: {}, { done, failed }?: { done: any; failed: any; }): Promise<any>;
    post(path: any, body?: {}, headers?: string, { done, failed }?: { done: any; failed: any; }): Promise<any>;
    put(path: any, body?: {}, { done, failed }?: { done: any; failed: any; }): Promise<any>;
    patch(path: any, body?: {}, { headers, done, failed }?: { done: any; failed: any; headers?: Promise<{ 'Content-Type': string; }>; }): any;
    delete // this.store = store;
    (// this.store = store;
      path: any, query?: {}, { headers, done, failed }?: { done: any; failed: any; headers?: Promise<{ 'Content-Type': string; }>; }): any;
  };

  constructor(path = '') {
    this.API_PATH = path + '/'
    this.ROOT_URL = SERVICES_CONFIG.API_ENDPOINT;
    this.api = helper.apiHelper(this.ROOT_URL, { axios: axios.create() });
    // this.store = store;
    this.api.createAxiosResponseInterceptor();
  }

}